export default "__VITE_ASSET__hPSuBTqq__"